export default {
    _prefix: "Survey",
    labels: {
        completed: {
            poweredBy: "Powered by Genesys Cloud",
            thankyou: "This survey is complete. Thank you for your submission!",
        },
        expired: "This survey link is invalid or has expired.",
        errors: {
            "saveFail.default.message":
                "The attempt to save the survey answers has failed.",
            "saveSuccess.message":
                "Your progress on the survey was successfully saved.",
            "alreadyFinished.message": "This has already been completed.",
            "submitFail.default.message":
                "The attempt to submit the survey answers has failed.",
        },
    },
};
